import noop from 'lodash-es/noop';
import type { ReactNode } from 'react';
import { createContext, useMemo, useState } from 'react';

interface Props {
  children: ReactNode;
}

interface ProductsTableContext {
  canEditProducts?: boolean;
  setCanEditProducts: (canEdit: boolean) => void;
}

export const ProductsTableContext = createContext<ProductsTableContext>({
  setCanEditProducts: noop,
});

export const ProductsTableProvider = ({ children }: Props) => {
  // Catchall for published/unpublished/hidden permissions, switches based on currently selected table
  const [canEditProducts, setCanEditProducts] = useState(false);

  const contextValue = useMemo(
    () => ({
      canEditProducts,
      setCanEditProducts,
    }),
    [canEditProducts, setCanEditProducts]
  );

  return (
    <ProductsTableContext.Provider value={contextValue}>
      {children}
    </ProductsTableContext.Provider>
  );
};
